import type { LocalizedRelease } from "../../types";

export const releases: Record<string, LocalizedRelease> = {
  "1.1.1": {
    title: "稳定性优化",
    summary: "修复画布重绘闪烁，以及从睡眠唤醒时偶发的崩溃。",
    highlights: [
      "修复快速缩放后重绘画布的闪烁。",
      "解决从睡眠唤醒时偶发的崩溃。",
      "画布退到后台时，空闲 CPU 占用更低。",
    ],
  },
  "1.1.0": {
    title: "更快的画布，Agent 打底",
    summary: "重写渲染路径、重新设计命令面板，并为 Agent 铺好底层。",
    highlights: [
      "渲染路径重写，数百个窗口下平移依旧顺滑。",
      "命令面板重新设计，一步跳到任意窗口、主题或操作。",
      "为在画布上直接跑长时间 Agent 任务打好基础。",
      "内存占用更小，冷启动更快。",
    ],
  },
  "1.0.2": {
    title: "打磨与修复",
    summary: "高缩放下文字更清晰，项目切换更快。",
    highlights: [
      "高缩放级别下文字渲染更清晰。",
      "在近期项目之间切换更快。",
      "修复了一批窗口聚焦和键盘处理的问题。",
    ],
  },
  "1.0.0": {
    title: "CATE 1.0",
    summary: "首个稳定版正式发布，画布、终端、编辑器和浏览器全部就位。",
    highlights: [
      "无限缩放画布稳定可靠，足以扛起日常工作。",
      "终端、编辑器、浏览器都是一等窗口。",
      "工作区持久保存，原样恢复到你上次离开的样子。",
      "提供 macOS、Windows 和 Linux 版本。",
    ],
  },
  "0.9.3": {
    title: "Beta 收尾打磨",
    summary: "1.0 之前修复内存问题，并缩小安装体积。",
    highlights: [
      "修复了 Beta 期间发现的几处内存泄漏。",
      "安装体积明显瘦身。",
    ],
  },
  "0.9.0": {
    title: "公开 Beta",
    summary: "公开 Beta 上线，多窗口画布、持久化和主题悉数登场。",
    highlights: [
      "公开 Beta，人人都能下载试用 CATE。",
      "多窗口画布，布局可保存。",
      "全画面主题的初步尝试。",
    ],
  },
  "0.7.0": {
    title: "主题登场",
    summary: "首套内置主题，覆盖整个画面。",
    highlights: [
      "内置主题覆盖整块画布，而不只是编辑器。",
      "一个按键，浅色深色瞬间切换。",
    ],
  },
  "0.4.0": {
    title: "多面板画布",
    summary: "同时漂浮多个终端或编辑器，按空间自由摆放。",
    highlights: [
      "一次打开多个终端和编辑器。",
      "随手拖动窗口，按空间自由摆放。",
    ],
  },
  "0.1.0": {
    title: "首个 Alpha",
    summary: "最早的公开版本，一个终端落在无限缩放的平面上。",
    highlights: [
      "一个终端，落在一块无限缩放的平面上。",
      "整个构想最初的种子。",
    ],
  },
};
